import gql from 'graphql-tag';

export default gql`
  mutation updateModeloNota(
    $idModeloNota: String!
    $titulo: String!
    $descripcion: String!
    $htmlModeloNota: String!
    $organismos: [String]
    $talonarios: [InputParTalonario]
    $clasificadoresEstadisticos: [String]
  ) {
    updateModeloNota(
      idModeloNota: $idModeloNota
      titulo: $titulo
      descripcion: $descripcion
      htmlModeloNota: $htmlModeloNota
      organismos: $organismos
      talonarios: $talonarios
      clasificadoresEstadisticos: $clasificadoresEstadisticos
    ) {
      _id
      titulo
      descripcion
      htmlModelo
      talonarios {
        talonario {
          _id
          nombre
          cantidad
        }
        organismo {
          _id
          nombre
        }
      }
      organismos {
        _id
        nombre
      }
      clasificadoresEstadisticos {
        _id
        nombre
        descripcion
      }
    }
  }
`;
